import { Component, computed, inject, input } from '@angular/core';
import { EmptyClass, EventCategory, EventInfo } from 'in-time-core';
import { LocalizationMixinSignals } from '../../../../core/mixins/localization-mixin-signal';
import { getRouteForEventCategory } from '../../utility/route-utils';
import { Router } from '@angular/router';
import { getLocalizationKeyForEventCategory } from '../../utility/localization-utils';

@Component({
  selector: 'app-event-category-section',
  templateUrl: './event-category-section.component.html',
})
export class EventCategorySectionComponent extends LocalizationMixinSignals(EmptyClass) {
  public readonly router = inject(Router);

  public readonly category = input.required<EventCategory>();

  public readonly categoryLocalizationKey = computed(() => {
    return getLocalizationKeyForEventCategory(this.category());
  });

  public readonly events = input.required<EventInfo[]>();

  onShowAll(): void {
    const route = getRouteForEventCategory(this.category());

    this.router.navigateByUrl(route);
  }
}
